import React, { useState, useEffect, useCallback } from 'react';
import { Container, Card, Button, Badge, Row, Col, ListGroup, Navbar } from 'react-bootstrap';
import { itemService } from '../services/api';
import { useNavigate } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { Users, Home, User, ShoppingCart, ArrowRight } from 'lucide-react';

const Dashboard = () => {
    const [household, setHousehold] = useState(null);
    const [copied, setCopied] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const hId = localStorage.getItem('household_id');

    const loadData = useCallback(async () => {
        if (!hId || hId === "undefined") return navigate('/login');

        try {
            const data = await itemService.getHouseholdInfo(hId);
            if (data && data.invite_code) {
                setHousehold(data);
            } else {
                setError("Impossible de charger le foyer.");
            }
        } catch (err) {
            setError("Erreur de connexion au serveur.");
        }
    }, [hId, navigate]);

    useEffect(() => { loadData(); }, [loadData]);

    if (!household) return <div className="text-center mt-5">Chargement...</div>;

    const joinUrl = `${window.location.origin}/join?code=${household.invite_code}`;

    return (
        <div style={{ backgroundColor: '#f4f7f6', minHeight: '100vh', paddingBottom: '80px' }}>
            <Navbar bg="white" className="shadow-sm mb-4">
                <Container>
                    <Navbar.Brand className="fw-bold text-success">
                        <Home className="me-2" /> {household.name}
                    </Navbar.Brand>
                </Container>
            </Navbar>

            <Container>
                {error && <div className="alert alert-danger">{error}</div>}

                {/* --- BOUTON LARGE POUR RETOURNER À LA LISTE --- */}
                <Button 
                    variant="success" 
                    className="w-100 py-3 rounded-4 shadow-sm border-0 d-flex align-items-center justify-content-between px-4 mb-4"
                    onClick={() => navigate('/ma-liste')}
                >
                    <div className="d-flex align-items-center">
                        <ShoppingCart className="me-3" size={24} />
                        <div className="text-start">
                            <div className="fw-bold">Ma liste de courses</div>
                            <small style={{ opacity: 0.8 }}>Voir ou ajouter des articles</small>
                        </div>
                    </div>
                    <ArrowRight size={20} />
                </Button>

                <Row className="g-4">
                    <Col md={8}>
                        <Card className="border-0 shadow-sm rounded-4">
                            <Card.Body>
                                <Card.Title className="fw-bold mb-4 d-flex align-items-center">
                                    <Users className="me-2 text-success" /> Membres de la famille
                                </Card.Title>
                                <ListGroup variant="flush">
                                    {household.members && household.members.map(member => (
                                        <ListGroup.Item key={member.id} className="d-flex justify-content-between align-items-center border-0 px-0 py-3 border-bottom">
                                            <div className="d-flex align-items-center">
                                                <div className="bg-light p-2 rounded-circle me-3">
                                                    <User size={20} className="text-success" />
                                                </div>
                                                <div>
                                                    <div className="fw-bold">{member.name}</div>
                                                    <small className="text-muted">{member.role === 'admin' ? 'Chef de foyer' : 'Membre'}</small>
                                                </div>
                                            </div>
                                            {member.role === 'admin' && <Badge bg="success" pill>Admin</Badge>}
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4}>
                        <Card className="border-0 shadow-sm rounded-4 text-center">
                            <Card.Body className="py-4">
                                <QRCodeSVG value={joinUrl} size={120} className="mb-3" />
                                <div className="small text-muted mb-1">Code d'invitation</div>
                                <div className="h4 fw-bold text-success mb-3">{household.invite_code}</div>
                                <Button 
                                    variant={copied ? "dark" : "outline-success"} 
                                    className="w-100 rounded-pill"
                                    onClick={() => {
                                        navigator.clipboard.writeText(household.invite_code);
                                        setCopied(true);
                                        setTimeout(() => setCopied(false), 2000);
                                    }}
                                >
                                    {copied ? "Copié !" : "Copier le code"}
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                
                <div className="fixed-bottom p-3 bg-white border-top d-md-none text-center">
                    <Button variant="success" className="w-100 rounded-pill py-2 fw-bold" onClick={() => navigate('/ma-liste')}>
                        🛒 ALLER FAIRE LES COURSES
                    </Button>
                </div>
            </Container>
        </div>
    );
};

export default Dashboard;